/**
 * Is this a phone or a tablet? (ROADMAP 4.17; owner, 2026-10-17: *"disallow
 * accessing /index_admin route when on mobile device by pretending that the
 * route doesn't exist … this is for security measure"*.)
 *
 * By DEVICE, never by width: a desktop window narrowed to half the screen is
 * still the admin's desk (`usePhoneViewport` decides the phone LAYOUT by width,
 * deliberately — that is a different question). Read in order: the browser's
 * own client hint, then the user agent, then an iPad presenting as a Mac (iPadOS
 * sends a desktop user agent but has a touch screen).
 *
 * A browser can claim to be a desktop, so this is a layer, not the boundary —
 * the backend's admin check is.
 */
const MOBILE_UA = /Android|iPhone|iPad|iPod|Mobile|Windows Phone|BlackBerry|Opera Mini|IEMobile|Silk|Kindle/i;

export interface DeviceSignals {
  userAgent?: string;
  uaMobile?: boolean;
  platform?: string;
  maxTouchPoints?: number;
}

export function isMobileDevice(signals?: DeviceSignals): boolean {
  const nav = (typeof navigator !== 'undefined' ? navigator : undefined) as
    (Navigator & { userAgentData?: { mobile?: boolean } }) | undefined;
  const s: DeviceSignals = signals ?? {
    userAgent: nav?.userAgent,
    uaMobile: nav?.userAgentData?.mobile,
    platform: nav?.platform,
    maxTouchPoints: nav?.maxTouchPoints,
  };
  if (s.uaMobile === true) return true;
  if (s.userAgent && MOBILE_UA.test(s.userAgent)) return true;
  return s.platform === 'MacIntel' && (s.maxTouchPoints ?? 0) > 1;
}
